import { IQuery, Topics } from '@zaplify/common';

export class GetLinkedinProfileImagesQuery extends IQuery<Record<string, string>> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly userId: string, readonly prospectIds: string[]) {
        super();
    }
}
